import { useNavigate } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

import { useAddTradeDrawer } from "../components/trades/AddTradeDrawer";
import { TradesPage } from "./Trades";

export function CreateTradePage() {
  const navigate = useNavigate();
  const { open } = useAddTradeDrawer();
  const openedRef = useRef(false);

  useEffect(() => {
    if (openedRef.current) return;
    openedRef.current = true;
    open({
      onClose: () => {
        void navigate({ to: "/trades" });
      },
    });
  }, [open, navigate]);

  return <TradesPage />;
}
